export const EXPAND_NAVIGATION_COOKIE_KEY = 'expandNavigation'
export const COLLAPSE_DASHBOARD_RETURNS_COOKIE_KEY = 'collapseDashboardReturns'
export const APY_RANGE_SETTING_COOKIE_KEY = 'apyRangeSetting'
export const INCLUDE_REWARDS_SETTING_COOKIE_KEY = 'includeRewardsSetting'
export const TVL_RANGE_SETTING_COOKIE_KEY = 'tvlRangeSetting'
export const CHARTS_PERIOD_SETTINGS_COOKIE_KEY = 'chartsPeriodSetting'
export const APP_THEME_COOKIE_KEY = 'theme'
export const BENCHMARK_SELECTED_VAULTS_COOKIE_KEY = 'benchmarkSelectedVaults'
export const BENCHMARK_SELECTED_NETWORKS_COOKIE_KEY = 'benchmarkSelectedNetworks'
export const BENCHMARK_SELECTED_BENCHMARKS_COOKIE_KEY = 'benchmarkSelectedBenchmarks'
export const DASHBOARD_BREAKDOWN_TAB_COOKIE_KEY = 'dashboardBreakdownTab'
